var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 17,
    y1: 30,
    x2: 33,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 17,
    y1: 35,
    x2: 30,
    y2: 35
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,10h-13C17.672,10,17,9.328,17,8.5v-6C17,1.672,17.672,1,18.5,1h13C32.328,1,33,1.672,33,2.5v6C33,9.328,32.328,10,31.5,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.364,21.537c0-0.472,0-0.901,0-1.169c0.375-0.341,0.548-0.86,0.565-1.357c0.166-0.133,0.424-0.3,0.501-0.703c0.062-0.327-0.069-0.594-0.224-0.788c0.49-0.728,0.419-2.971-1.459-2.971L25.455,14c-2.727,0-3.68,1.975-2.897,3.655c-0.107,0.099-0.27,0.386-0.26,0.6c0.022,0.494,0.375,0.68,0.541,0.756c0.063,0.573,0.43,1.124,0.799,1.357c0,0.266,0,0.933,0,1.169C23.132,22.845,20,22.462,20,25h10C30,22.462,26.868,22.845,26.364,21.537z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41,3h-6v5h4v35H11V8h4V3H9C7.346,3,6,4.346,6,6v39c0,1.654,1.346,3,3,3h32c1.654,0,3-1.346,3-3V6C44,4.346,42.654,3,41,3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.f9bf89cd3f668c8199569a98c18ccb59.svg";
export { ForwardRef as ReactComponent };